import React from 'react';

const ReputationLinkTab = ({reputationLinks,getLinkIcon,formatDate}) => {
    return (
        <div>
            <div className="card border-0 shadow-sm">
                <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-0">
                        <i className="bi bi-link-45deg text-primary me-2"></i>
                        Reputation Links
                    </h5>
                    <button className="btn btn-primary">
                        <i className="bi bi-plus-circle me-2"></i>
                        Add Link
                    </button>
                </div>
                <div className="card-body">
                    {reputationLinks.length > 0 ? (
                        <div className="table-responsive">
                            <table className="table table-hover align-middle">
                                <thead>
                                <tr>
                                    <th>Platform</th>
                                    <th>Link</th>
                                    <th>Status</th>
                                    <th>Created</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {reputationLinks.map((link) => (
                                    <tr key={link.id}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <i className={`bi ${getLinkIcon(link.linkType)} me-2 fs-5`}></i>
                                                <span className="fw-semibold">{link.linkType}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <a href={link.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                                {link.link}
                                            </a>
                                        </td>
                                        <td>
                                                        <span className={`badge ${link.isActive ? 'bg-success' : 'bg-secondary'}`}>
                                                            <i className={`bi ${link.isActive ? 'bi-check-circle' : 'bi-pause-circle'} me-1`}></i>
                                                            {link.isActive ? 'Active' : 'Inactive'}
                                                        </span>
                                        </td>
                                        <td>
                                            <small className="text-muted">{formatDate(link.createdAt)}</small>
                                        </td>
                                        <td>
                                            <div className="btn-group">
                                                <button className="btn btn-outline-primary btn-sm">
                                                    <i className="bi bi-pencil"></i>
                                                </button>
                                                <button className="btn btn-outline-danger btn-sm">
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <i className="bi bi-link-45deg display-1 text-muted"></i>
                            <h5 className="text-muted mt-3">No reputation links</h5>
                            <p className="text-muted">Add links to your social media and review platforms</p>
                            <button className="btn btn-primary">
                                <i className="bi bi-plus-circle me-2"></i>
                                Add Your First Link
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReputationLinkTab;